import React from 'react';
import { motion } from 'framer-motion';
import './RACOwnership.css';

const RACOwnership = () => {
  console.log('[RACOwnership] Component rendered');
  
  return (
    <section className="rac-ownership">
      <div className="rac-ownership-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-ownership-content"
        >
          <h2 className="rac-section-title">What It Means to Own a Cow</h2>
          <div className="rac-gold-line"></div>
          <div className="rac-ownership-text">
            <p>
              Owning a cow through RAC is stewardship, not speculation.
            </p>
            <p>
              You own a real, insured dairy animal. You know where it lives. You receive daily photos, health logs, feeding records, and activity updates.
            </p>
            <p>
              This ownership brings pride without anxiety, income without noise, and a sense of connection to land and food.
            </p>
            <p className="rac-ownership-tagline">
              This is quiet confidence.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RACOwnership;


